import DealsList from "./DealsList";
import DealListing from "./DealListing";

export { DealListing };
export default DealsList;
